import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { NavMarker } from 'react-rhumb';
// @ts-expect-error untyped
import { useFeedbackLoader } from 'feedback-loader/useFeedbackLoader';
import enviro from 'enviro';
import PortalIdParser from 'PortalIdParser';

// @ts-expect-error this file has no types
import ProvideReferenceResolvers from 'reference-resolvers/ProvideReferenceResolvers';
import { DEAL_PROPERTY, DEAL_PIPELINE, DEAL_PIPELINE_STAGE
// @ts-expect-error this file has no types
} from 'reference-resolvers/constants/ReferenceObjectTypes';
// @ts-expect-error this file has no types
import DealPropertyReferenceResolver from 'reference-resolvers/resolvers/DealPropertyReferenceResolver';
// @ts-expect-error this file has no types
import PipelineReferenceResolver from 'reference-resolvers/resolvers/PipelineReferenceResolver';
// @ts-expect-error this file has no types
import PipelineStageReferenceResolver from 'reference-resolvers/resolvers/PipelineStageReferenceResolver';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { ListingPage } from 'foundations-components/transitional/components/ListingPage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useTheme } from 'styled-components';
import { TEAMS, DEALS_TAB } from '../constants/OverviewConstants';
import { SUCCEEDED } from '../constants/RequestStatusTypes';
import { DEAL_STAGE, FORECAST_CATEGORY } from '../constants/DealGroupingType';
import RepOverviewTableContainer from '../components/RepOverviewTableContainer';
import { OverviewBreadcrumbs } from '../components/OverviewBreadcrumbs';
import ExchangeRateAlert from '../components/alerts/ExchangeRateAlert';
import DealSidebarContainer from '../components/dealSidebar/DealSidebarContainer';
import ProcessingAlert from '../components/alerts/ProcessingAlert';
import NewYearAlert from '../components/alerts/NewYearAlert';
import CategoryForecastingSetup from '../components/categoryForecasting/CategoryForecastingSetup';
import ForecastHeader from '../components/headers/ForecastHeader';
import ForecastFilters from '../components/filters/ForecastFilters';
import { getHasAggregatedOverviewFetchError, getRowForId, getRows } from '../selectors/aggregatedOverviewDataSelectors';
import { getHasSuperAdminScope, getHasViewOwnedOnlyPermission, getIsUngatedToForecastingMultipleOutcomes, getUserPrimaryTeam } from '../selectors/authSelectors';
import { deriveNewYearAlertState, getShowProcessingAlert, getShouldShowGoalsBugAlert } from '../selectors/alertsSelectors';
import { getBreadcrumbTrail, getDealSidebarId } from '../selectors/overviewSelectors';
import { getTeamsMap, getTeamsStatus } from '../selectors/usersSelectors';
import { getShowForecastCategoryWizard, getShowWizardFetchSucceeded } from '../selectors/setupSelectors';
import { getDealGroupingTypeFilter, getForecastTypeFilter } from '../selectors/filtersSelectors';
import { getUserHasAccessToNoForecastTypes } from '../selectors/forecastSelectors';
import { setDealSidebarOwnerId } from '../actions/OverviewDataActions';
import { fetchCurrencyInfoAction } from '../actions/MultiCurrencyActions';
import { selectTeam, buildBreadcrumbs, clearBreadcrumbs } from '../actions/OverviewDataActions';
import { fetchAggregatedOverviewData, fetchInitialOverviewData, toggleAggregatedDealRollupFetching, toggleAggregatedGoalsFetching, toggleAggregatedSubmissionsFetching } from '../actions/AggregatedOverviewDataActions';
import { fetchPortalWideCadence } from '../actions/ForecastActions';
import useFetchPreferredCurrency from '../components/multicurrency/hooks/useFetchPreferredCurrency';
import { getTeamIdFromUrl } from '../utils/teamUtils';
import { getHasSeenDealStageForecastTour, getHasSeenFmoMigrationTour } from '../selectors/displayOptionsSelectors';
import DealGroupingTypeFilter from '../components/filters/DealGroupingTypeFilter';
import { CreateForecastTypeWizardWrapper } from '../components/fmo/CreateForecastTypeWizardWrapper';
import { PORTAL_ACTIVATION } from '../utils/tourUtils';
import { getHasPortalSeenActivationModal } from '../selectors/onboardingSettingsSelectors';
import TourSwitch from '../components/tour/TourContainer';
import { ForecastTypePermissionError } from '../components/fmo/ForecastTypePermissionError';
import GoalsBugAlert from '../components/alerts/GoalsBugAlert';
import { HUBSPOT_DEFINED_FORECAST_TYPE_ID } from '../constants/ForecastTypeConstants';
import { PROD_FMO_SURVEY_ID, QA_FMO_SURVEY_ID } from '../constants/FiltersConstants';
import useOnboardingIntroModal from '../hooks/useOnboardingIntroModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const OverviewWrapper = ({
  navMarkerLabel,
  children
}) => {
  const theme = useTheme();
  return /*#__PURE__*/_jsx(NavMarker, {
    name: navMarkerLabel,
    children: /*#__PURE__*/_jsx(ListingPage, {
      "data-test-id": "rep-overview-container",
      headerComponent: /*#__PURE__*/_jsx(ForecastHeader, {
        isDetail: false
      }),
      mainSectionBackgroundColor: theme.color['fill-surface-raised'],
      pageLayout: "full-width",
      children: children
    })
  });
};
const RepOverviewContainer = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const teamIdFromUrl = getTeamIdFromUrl(location);
  const {
    data: preferredCurrency
  } = useFetchPreferredCurrency();

  // Auth
  const isFmoEnabled = useSelector(getIsUngatedToForecastingMultipleOutcomes);
  const isSuperAdmin = useSelector(getHasSuperAdminScope);

  // Alerts and Tours
  const showProcessingAlert = useSelector(getShowProcessingAlert);
  const showNewYearAlert = useSelector(deriveNewYearAlertState);
  const hasSeenOnboardingV1Tour = useSelector(getHasSeenDealStageForecastTour);
  const hasPortalSeenActivationModal = useSelector(getHasPortalSeenActivationModal);
  const hasSeenMigrationTour = useSelector(getHasSeenFmoMigrationTour);
  // Teams
  const teams = useSelector(getTeamsMap);
  const teamsStatus = useSelector(getTeamsStatus);
  const userPrimaryTeam = useSelector(getUserPrimaryTeam);

  // Other
  const rowData = useSelector(getRows);
  const sidebarRowData = useSelector(getRowForId);
  const selectedDealSidebarOwner = useSelector(getDealSidebarId);
  const breadcrumbTrail = useSelector(getBreadcrumbTrail);
  const hasViewOwnedOnlyPermission = useSelector(getHasViewOwnedOnlyPermission);
  const dealGroupingType = useSelector(getDealGroupingTypeFilter);
  const hasAggregatedOverviewDataFetchError = useSelector(getHasAggregatedOverviewFetchError);
  const userHasAccessToNoForecastTypes = useSelector(getUserHasAccessToNoForecastTypes);
  const selectedForecastType = useSelector(getForecastTypeFilter);
  const showGoalsBugAlert = useSelector(getShouldShowGoalsBugAlert);

  // Wizard
  const showWizardFetchSucceeded = useSelector(getShowWizardFetchSucceeded);
  const showForecastCategoryWizard = useSelector(getShowForecastCategoryWizard);
  const readyToRenderOverviewTable = dealGroupingType === DEAL_STAGE || showWizardFetchSucceeded;

  //Flywheel survey
  const QA_FLYWHEEL_SURVEY_ID = 432;
  const PROD_FLYWHEEL_SURVEY_ID = 1158;
  const portalId = PortalIdParser.get();
  const isPortal53 = enviro.isProd() ? portalId === 53 : portalId === 99535353;
  const {
    loadSurvey,
    clientLoaded
  } = useFeedbackLoader();

  // Tours
  const [tourToDisplay, setTourToDisplay] = useState(null);
  const {
    startTour
  } = useOnboardingIntroModal({
    setSeenWithStartTour: true
  });
  const onboardingOnCloseFunction = useCallback(() => tourToDisplay === PORTAL_ACTIVATION ? startTour() : null, [tourToDisplay, startTour]);
  useEffect(() => {
    if (hasAggregatedOverviewDataFetchError || userHasAccessToNoForecastTypes || showForecastCategoryWizard || !clientLoaded) {
      return;
    }
    if (isPortal53) {
      const flywheelSurveyId = enviro.isProd() ? PROD_FLYWHEEL_SURVEY_ID : QA_FLYWHEEL_SURVEY_ID;
      loadSurvey(flywheelSurveyId, 'CSAT');
    }

    // Show FMO CSAT when user has a non-default forecast type selected
    if (isFmoEnabled && selectedForecastType !== HUBSPOT_DEFINED_FORECAST_TYPE_ID) {
      loadSurvey(enviro.isProd() ? PROD_FMO_SURVEY_ID : QA_FMO_SURVEY_ID, 'CSAT');
    }
  }, [clientLoaded, hasAggregatedOverviewDataFetchError, isFmoEnabled, isPortal53, loadSurvey, selectedForecastType, showForecastCategoryWizard, userHasAccessToNoForecastTypes]);

  // Fetch data upon rendering
  useEffect(() => {
    dispatch(fetchInitialOverviewData()).catch(() => {
      /* handled in fetchAggreInitialOverviewData */
    });
    Promise.all([dispatch(fetchCurrencyInfoAction()), dispatch(fetchPortalWideCadence())]).then(() => {
      dispatch(fetchAggregatedOverviewData()).catch(() => {
        /* handled in fetchAggregatedOverviewData */
      });
    }).catch(() => {});
  }, [dispatch, teamIdFromUrl]);

  // Navigate to correct team based on url
  useEffect(() => {
    // when you directly link to a team, we want to verify the validity of the team ID in the URL before calling the selectTeam action
    if (teamsStatus === SUCCEEDED) {
      if (!teamIdFromUrl) {
        dispatch(clearBreadcrumbs());
        return;
      }

      // handles errors caused by users with owned-only permissions linking to teams they are not on
      if (hasViewOwnedOnlyPermission && userPrimaryTeam && userPrimaryTeam.id !== Number(teamIdFromUrl)) {
        dispatch(clearBreadcrumbs());
        history.push(`/${TEAMS}`);
        return;
      }

      // if the team in the location is invalid, go back to teams overview
      if (!teams.has(Number(teamIdFromUrl))) {
        dispatch(clearBreadcrumbs());
        history.push(`/${TEAMS}`);
        return;
      }
      dispatch(selectTeam(Number(teamIdFromUrl)));
    }

    // when you directly link to a team and there isn't a breadcrumbTrail from the store
    const buildBreadcrumbsDirectLink = teams.size > 0 && teamIdFromUrl;
    if (buildBreadcrumbsDirectLink) {
      dispatch(buildBreadcrumbs(teamIdFromUrl, teams));
    }
  }, [dispatch, hasViewOwnedOnlyPermission, history, teamIdFromUrl, teams, teamsStatus, userPrimaryTeam]);
  const handleSelectUserOrTeam = ({
    ownerId,
    teamId
  }) => {
    const ownerPath = `/owner/${ownerId}`;
    if (!teamId) {
      dispatch(toggleAggregatedDealRollupFetching(true));
      dispatch(toggleAggregatedGoalsFetching(true));
      dispatch(toggleAggregatedSubmissionsFetching(true));
      history.push(ownerPath);
    } else {
      history.push(`/${TEAMS}/${teamId}`);
      if (ownerId) setDealSidebarOwnerId({
        dealSidebarId: ownerId,
        isTeam: false,
        defaultTab: DEALS_TAB
      });
    }
  };
  if (hasAggregatedOverviewDataFetchError) {
    return /*#__PURE__*/_jsx(OverviewWrapper, {
      navMarkerLabel: "OVERVIEW_INDEX_FAILED",
      children: /*#__PURE__*/_jsx(ErrorMessage, {
        type: "badRequest",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "repOverviewTable.fetchErrorMessage"
        })
      })
    });
  }
  if (userHasAccessToNoForecastTypes) {
    return /*#__PURE__*/_jsx(OverviewWrapper, {
      navMarkerLabel: "OVERVIEW_INDEX_LOAD",
      children: /*#__PURE__*/_jsx(ForecastTypePermissionError, {
        isDetail: false
      })
    });
  }
  const showCategoryForecastingSetup = dealGroupingType === FORECAST_CATEGORY && showForecastCategoryWizard;
  if (showCategoryForecastingSetup) {
    return /*#__PURE__*/_jsxs(OverviewWrapper, {
      navMarkerLabel: "OVERVIEW_INDEX_LOAD",
      children: [/*#__PURE__*/_jsx(DealGroupingTypeFilter, {}), /*#__PURE__*/_jsx(CategoryForecastingSetup, {
        onConfirm: fetchAggregatedOverviewData
      })]
    });
  }
  return /*#__PURE__*/_jsxs(OverviewWrapper, {
    navMarkerLabel: "OVERVIEW_INDEX_LOAD",
    children: [showGoalsBugAlert && /*#__PURE__*/_jsx(GoalsBugAlert, {}), showProcessingAlert && /*#__PURE__*/_jsx(ProcessingAlert, {}), showNewYearAlert && /*#__PURE__*/_jsx(NewYearAlert, {}), /*#__PURE__*/_jsx(ExchangeRateAlert, {}), /*#__PURE__*/_jsx(ForecastFilters, {
      handleSelectUserOrTeam: handleSelectUserOrTeam,
      isDetail: false
    }), /*#__PURE__*/_jsx(OverviewBreadcrumbs, {
      breadcrumbTrail: breadcrumbTrail
    }), readyToRenderOverviewTable && /*#__PURE__*/_jsx(RepOverviewTableContainer, {
      isDetailPage: false,
      preferredCurrency: preferredCurrency
    }), selectedDealSidebarOwner && sidebarRowData && /*#__PURE__*/_jsx(DealSidebarContainer, {}), /*#__PURE__*/_jsx(TourSwitch, {
      dispatch: dispatch,
      rowData: rowData,
      isFmoEnabled: isFmoEnabled,
      isSuperAdmin: isSuperAdmin,
      hasPortalSeenActivationModal: hasPortalSeenActivationModal,
      hasSeenMigrationTour: hasSeenMigrationTour,
      hasSeenOnboardingV1Tour: hasSeenOnboardingV1Tour,
      tourToDisplay: tourToDisplay,
      setTourToDisplay: setTourToDisplay,
      startTour: startTour
    }), /*#__PURE__*/_jsx(CreateForecastTypeWizardWrapper, {
      handleCancelWizard: onboardingOnCloseFunction
    })]
  });
};
export default ProvideReferenceResolvers({
  [DEAL_PROPERTY]: DealPropertyReferenceResolver,
  [DEAL_PIPELINE]: PipelineReferenceResolver,
  [DEAL_PIPELINE_STAGE]: PipelineStageReferenceResolver
})(RepOverviewContainer);